/**
 * Static files under /public/brands/*.png — „Pagal gamintoją“ kortelės.
 */
export const CATEGORY_BRAND_LOGO_FILES = {
  iphone: 'apple.png',
  apple: 'apple.png',
  samsung: 'samsung.png',
  nokia: 'nokia.png',
  google: 'google.png',
  xiaomi: 'xiaomi.png',
  motorola: 'motorola.png',
  huawei: 'huawei.png',
  oneplus: 'oneplus.png',
  sony: 'sony.png',
  honor: 'honor.png',
  asus: 'asus.png',
  nothing: 'nothing.png',
  fold: 'fold.png',
  all: 'all.png',
} as const

export type CategoryBrandLogoKey = keyof typeof CATEGORY_BRAND_LOGO_FILES

export function brandLogoPublicUrl(logoFile: string): string {
  return `/brands/${logoFile}?v=4`
}
